import { useGetAreasQuery } from 'api/AreasEndPoints';
import TopArea from 'modules/Dashboard/TopArea';
import { useMemo } from 'react';
import Loader from 'shared/component/Loader';
import { Statistics } from 'shared/model/statistic.model';

type Props = {
  stats?: Statistics;
};

const TopAreas = ({ stats }: Props) => {
  const { data, isLoading } = useGetAreasQuery(
    {
      fields: ['id', 'name'],
      where: {
        id: {
          inq: stats?.topAreas.map(a => a.areaId),
        },
      },
    },
    {
      skip: !stats,
    },
  );

  const areas = data ?? [];

  const tops = useMemo(() => {
    if (!stats) return [];
    return stats.topAreas.map(area => {
      const result = {
        ...area,
      };
      const found = areas.find(a => a.id === area.areaId);
      if (found?.name) {
        result.name = found.name;
      }
      return result;
    });
  }, [areas, stats]);

  if (isLoading) {
    return <Loader />;
  }

  return (
    <div>
      {tops.map(item => {
        return <TopArea key={item.areaId} item={item} />;
      })}
    </div>
  );
};

export default TopAreas;
